var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ckeditor',{attrs:{"editor":_vm.editor,"value":_vm.value,"config":_vm.editorConfig,"disabled":_vm.disabled},on:{"input":_vm.handleInput,"blur":_vm.handleBlur,"focus":_vm.handleFocus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }